import request from '@/utils/request'


// 查询医院认证信息列表
export function listAuth(query) {
  return request({
    url: '/hospital/auth/list',
    method: 'get',
    params: query
  })
}

// 查询医院认证信息分页
export function pageAuth(query) {
  return request({
    url: '/hospital/auth/page',
    method: 'get',
    params: query
  })
}

// 查询医院认证信息详细
export function getAuth(data) {
  return request({
    url: '/hospital/auth/detail',
    method: 'get',
    params: data
  })
}

// 新增医院认证信息
export function addAuth(data) {
  return request({
    url: '/hospital/auth/add',
    method: 'post',
    data: data
  })
}

// 修改医院认证信息
export function updateAuth(data) {
  return request({
    url: '/hospital/auth/edit',
    method: 'post',
    data: data
  })
}

export function checkHospital(data) {
  return request({
    url: '/hospital/auth/check',
    method: 'post',
    data: data
  })
}

// 删除医院认证信息
export function delAuth(data) {
  return request({
    url: '/hospital/auth/delete',
    method: 'post',
    data: data
  })
}
